export const PLUGIN_CONFIG_ANALYTICS_PROPERTIES_KEYS: any = {
  customDimension1: 'custom_dimension_1',
  customDimension2: 'custom_dimension_2',
  customDimension3: 'custom_dimension_3',
  customDimension4: 'custom_dimension_4',
  customDimension5: 'custom_dimension_5',
  customDimension6: 'custom_dimension_6',
  customDimension7: 'custom_dimension_7',
  customDimension8: 'custom_dimension_8',
  customDimension9: 'custom_dimension_9',
  customDimension10: 'custom_dimension_10',
};

export const ANALYTICS_PROPERTIES_KEYS: any = {
  customDimension1: 'custom_1',
  customDimension2: 'custom_2',
  customDimension3: 'custom_3',
  customDimension4: 'custom_4',
  customDimension5: 'custom_5',
  customDimension6: 'custom_6',
  customDimension7: 'custom_7',
  customDimension8: 'custom_8',
  customDimension9: 'custom_9',
  customDimension10: 'custom_10',
};
